var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubIdentityRemoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8335 4.16634C3.8335 2.60153 5.10202 1.33301 6.66683 1.33301C8.23161 1.33301 9.50016 2.60153 9.50016 4.16634C9.50016 5.73113 8.23162 6.99967 6.66683 6.99967C5.10202 6.99967 3.8335 5.73112 3.8335 4.16634ZM6.66683 2.83301C5.93045 2.83301 5.3335 3.42996 5.3335 4.16634C5.3335 4.90271 5.93045 5.49967 6.66683 5.49967C7.40319 5.49967 8.00016 4.9027 8.00016 4.16634C8.00016 3.42997 7.40319 2.83301 6.66683 2.83301ZM17.8735 14.7305C17.8735 15.1447 17.5378 15.4805 17.1235 15.4805H10.7505C10.3363 15.4805 10.0005 15.1447 10.0005 14.7305C10.0005 14.3163 10.3363 13.9805 10.7505 13.9805H17.1235C17.5378 13.9805 17.8735 14.3163 17.8735 14.7305ZM3.66699 12.5C3.66699 10.8431 5.01014 9.5 6.66699 9.5C7.82775 9.5 8.83584 10.159 9.33517 11.1269C9.44177 11.3335 9.52496 11.5539 9.58138 11.7847C9.67971 12.1871 10.0856 12.4336 10.488 12.3353C10.8904 12.2369 11.1368 11.831 11.0385 11.4287C10.9536 11.0812 10.8284 10.7495 10.6682 10.4391C9.92163 8.99206 8.4108 8 6.66699 8C4.18171 8 2.16699 10.0147 2.16699 12.5V17.0833C2.16699 17.9578 2.87587 18.6667 3.75033 18.6667H10.417C10.8312 18.6667 11.167 18.3309 11.167 17.9167C11.167 17.5025 10.8312 17.1667 10.417 17.1667H3.75033C3.7043 17.1667 3.66699 17.1294 3.66699 17.0833L3.66699 12.5Z",
    fill: "#EE4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubIdentityRemoved);
export default __webpack_public_path__ + "static/media/sub-identity-removed.d348ba8a5114002b19eb6482129d9dcc.svg";
export { ForwardRef as ReactComponent };